import React from 'react';
import { ANDROID_PLATFORM, DEFAULT_PLATFORM, IOS_PLATFORM, OS_LIST, OTHER_PLATFORM, WEB_PLATFORM } from '../constants';
import { getPlatformDisplayName, getPlatformOption } from '../utils';

export const STORE_SELECTION_PLATFORMS = [ANDROID_PLATFORM, IOS_PLATFORM, WEB_PLATFORM];
export const MANUAL_PUBLIC_ID_PLATFORMS = ['metaquest', 'nintendo', 'pc', 'ctv', 'xbox', 'playstation'];

export const getOtherPlatformOptions = (platforms = []) =>
    platforms.filter(platform => {
        const platformName = String(platform.name || '').toLowerCase();
        return platformName !== OTHER_PLATFORM && !OS_LIST.includes(platformName);
    });

export const getOtherPlatformDropdownItems = platforms =>
    platforms.map(platform => ({
        ...platform,
        display_name: React.createElement('span', null, platform.display_name || platform.name),
    }));

export const formatPurchaseEnforcementDate = date => {
    if (!date) return '';
    if (date instanceof Date) return date.toISOString().slice(0, 10);
    if (typeof date === 'string' && date.includes('T')) return date.slice(0, 10);
    return String(date);
};

export const getDraftPlatformSelection = (platforms, platformName) => {
    if (platformName === OTHER_PLATFORM) {
        return {
            os: { name: OTHER_PLATFORM, display_name: getPlatformDisplayName(OTHER_PLATFORM) },
            platform: getOtherPlatformOptions(platforms)[0] || {
                name: OTHER_PLATFORM,
                display_name: getPlatformDisplayName(OTHER_PLATFORM),
            },
        };
    }

    const platform = getPlatformOption(platformName, platforms);
    return { os: platform, platform };
};

export const getDefaultPlatformName = platformNames =>
    platformNames.includes(DEFAULT_PLATFORM) ? DEFAULT_PLATFORM : platformNames[0] || DEFAULT_PLATFORM;
